<app-title [title]="title"></app-title>

<form class="table" [formGroup]="tableFormGroup">
  <div class="table--header">
    <div *ngFor="let c of columnTitles">
      <div class="column-title">
        {{ c }}
      </div>
    </div>
  </div>
  <div class="table--row" *ngFor="let fg of getFormArray().controls; let i = index" (click)="selectedRow = i">
    <ng-container *ngFor="let c of columns; let ci = index">
      <div class="col" *ngIf="c.type === 'table_column_dropdown_select' || c.type === 'dropdown_select'">
        <div class="input-title" *ngIf="isTableBig">
          {{ columnTitles[ci] }}
        </div>
        <select
          [class.select-blue]="i === selectedRow"
          [formControl]="getControlAsFormControl(fg, 'control' + ci)"
          [class.disabled]="formControl.disabled"
        >
          <option *ngIf="c.placeholder" [value]="null" disabled>{{ c.placeholder }}</option>
          <option *ngFor="let column of c.options" [value]="column.id">{{ column.text }}</option>
        </select>
        <app-error-message
          type="table-err"
          *ngIf="getControlAsFormControl(fg, 'control' + ci).errors && getControlAsFormControl(fg, 'control' + ci).touched"
          [validationErrors]="getControlAsFormControl(fg, 'control' + ci).errors"
        ></app-error-message>
      </div>
      <div class="col" *ngIf="c.type === 'table_column_simple_input' || c.type === 'simple_input'">
        <div class="input-title" *ngIf="isTableBig">
          {{ columnTitles[ci] }}
        </div>
        <input
          type="text"
          [placeholder]="c.placeholder"
          [formControl]="getControlAsFormControl(fg, 'control' + ci)"
          [class.disabled]="formControl.disabled"
        />
        <app-error-message
          type="table-err"
          *ngIf="getControlAsFormControl(fg, 'control' + ci).errors && getControlAsFormControl(fg, 'control' + ci).touched"
          [validationErrors]="getControlAsFormControl(fg, 'control' + ci).errors"
        ></app-error-message>
      </div>

      <div class="col" *ngIf="c.type === 'table_column_date_picker' || c.type === 'date_picker'">
        <div class="input-title" *ngIf="isTableBig">
          {{ columnTitles[ci] }}
        </div>
        <app-custom-date-picker
          class="date-picker"
          [formControl]="getControlAsFormControl(fg, 'control' + ci)"
          [withTime]="c.withTime"
          [required]="!!c.required"
          [usedInTable]="true"
          [class.disabled]="formControl.disabled"
        >
        </app-custom-date-picker>
        <app-error-message
          type="table-err"
          *ngIf="getControlAsFormControl(fg, 'control' + ci).errors && getControlAsFormControl(fg, 'control' + ci).touched"
          [validationErrors]="getControlAsFormControl(fg, 'control' + ci).errors"
        ></app-error-message>
      </div>
      <div class="col" *ngIf="c.type === 'table_column_checkbox' || c.type === 'checkbox'">
        <div class="input-title" *ngIf="isTableBig">
          {{ columnTitles[ci] }}
        </div>
        <input
          [placeholder]="c.placeholder"
          [formControl]="getControlAsFormControl(fg, 'control' + ci)"
          type="checkbox"
          class="checkbox"
          [class.disabled]="formControl.disabled"
        />
        <app-error-message
          type="table-err"
          *ngIf="getControlAsFormControl(fg, 'control' + ci).errors && getControlAsFormControl(fg, 'control' + ci).touched"
          [validationErrors]="getControlAsFormControl(fg, 'control' + ci).errors"
        ></app-error-message>
      </div>
    </ng-container>
    <div class="trash" [class.disabled]="formLength === minColumn || formControl.disabled" (click)="removeRowFromFormArrayAt(i)">
      <span nz-icon nzType="delete" nzTheme="outline"></span>
    </div>
  </div>
  <app-error-message
    type="table"
    *ngIf="formControl.errors && formControl.touched"
    [validationErrors]="formControl.errors"
  ></app-error-message>
  <div
    class="new-line read-only-button"
    [class.disabled]="(maxColumn && formLength === maxColumn) || formControl.disabled"
    (click)="pushNewRowToFormArray()"
  >
    + {{ 'buttons.newRow' | translate }}
  </div>
</form>
